import React from "react";
import { NavLink } from "react-router-dom";

const Link = ({ href, isExternal = false, className = "", content }) => {
  const classes = `link--cta ${className}`;
  const externalAttrs = isExternal
    ? { target: "_blank", rel: "noopener noreferrer" }
    : {};

  return (
    <NavLink to={href} className={classes} {...externalAttrs}>
      {content}
    </NavLink>
  );
};

export default Link;
